var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_56_6",
    "data-name": "Component 56 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M11.49,3.17a1.534,1.534,0,0,0-2.98,0,1.532,1.532,0,0,1-2.286.948A1.532,1.532,0,0,0,4.118,6.224a1.533,1.533,0,0,1-.947,2.287,1.532,1.532,0,0,0,0,2.978,1.532,1.532,0,0,1,.947,2.287,1.532,1.532,0,0,0,2.106,2.106,1.532,1.532,0,0,1,2.287.947,1.532,1.532,0,0,0,2.978,0,1.533,1.533,0,0,1,2.287-.947,1.532,1.532,0,0,0,2.106-2.106,1.533,1.533,0,0,1,.947-2.287,1.532,1.532,0,0,0,0-2.978,1.532,1.532,0,0,1-.947-2.287,1.532,1.532,0,0,0-2.106-2.106,1.532,1.532,0,0,1-2.287-.947ZM10,13a3,3,0,1,0-3-3A3,3,0,0,0,10,13Z",
    transform: "translate(-2 -2)",
    fill: "#bec4cc",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.b73c058f33bef160ea85f092f3a8a558.svg";
export { ForwardRef as ReactComponent };